import Vue from 'vue';
import { defaultUpload } from './state';

const SET_CLASS_SYLLABUS = (state, { classId, syllabus }) => {
  Vue.set(state.byClass, classId, syllabus || null);
  Vue.set(state.loadedClasses, classId, true);
};

const SET_UPLOAD = (state, patch) => {
  state.upload = { ...state.upload, ...patch };
};

const RESET_UPLOAD = (state) => {
  state.upload = defaultUpload();
};

// Forgets the cached answer so the next loadClassSyllabus asks the server again.
const INVALIDATE_CLASS_SYLLABUS = (state, classId) => {
  Vue.delete(state.loadedClasses, classId);
};

const SET_CHECK_AGAIN = (state, { classId, value }) => {
  if (value) Vue.set(state.checkAgain, classId, true);
  else Vue.delete(state.checkAgain, classId);
};

const SET_LAST_ERROR = (state, error) => {
  state.lastError = error || null;
};

const COUNT_LESSON_RETRY = (state, syllabusId) => {
  Vue.set(state.lessonRetries, syllabusId, (state.lessonRetries[syllabusId] || 0) + 1);
};

export default {
  SET_CLASS_SYLLABUS,
  SET_UPLOAD,
  RESET_UPLOAD,
  INVALIDATE_CLASS_SYLLABUS,
  SET_CHECK_AGAIN,
  SET_LAST_ERROR,
  COUNT_LESSON_RETRY
};



// WEBPACK FOOTER //
// ./src/store/modules/syllabus/mutations.js